import { Helmet } from 'react-helmet-async';

import { CONFIG } from 'src/config-global';

import { NotFoundView, View403 } from 'src/sections/error';

// ----------------------------------------------------------------------

export default function ErrorPage403() {
  return (
    <>
      <View403 />
    </>
  );
}
